import { DRAG_HANDLE_CLASS } from 'constants/bounding-box';
import { WidgetId } from 'types/idTypes';
import { getElementForWidgetId } from 'utils/dom';
import { GroupWidgetData } from 'widgets/GroupWidget/GroupWidget.types';
import { WidgetMap } from 'widgets/Widget.types';
import { GroupIdCache } from 'widgets/sdk/GroupIdCache';

/**
 * Given an array of selected widget elements
 * get the group member elements and filter out any drag handle controls
 *
 * @param selectedWidgetElements - array of selected widget elements (from Selecto)
 * @param widgets - the widget map
 * @param groupIdCache - the group id cache to lookup group parent
 *
 * @returns array of target elements (for the bounding box rect)
 */
export const getSelectedWidgetTargetEls = (
  selectedWidgetElements: HTMLElement[],
  widgets: WidgetMap,
  groupIdCache: GroupIdCache,
) => {
  const targetElements: HTMLElement[] = [];
  let addedIds: { [id: WidgetId]: boolean } = {};

  for (let i = 0; i < selectedWidgetElements.length; i++) {
    const el = selectedWidgetElements[i];
    const id = el.id;
    if (!id) continue;

    // if the classlist has custom-drag-handle-control then continue
    if (el.classList.contains(DRAG_HANDLE_CLASS)) continue;

    // if the target has been added already continue
    if (addedIds[id]) continue;

    // if its not a group add the element to the target elements
    const parentId = groupIdCache.getParentIdNested(id);
    if (!parentId) {
      targetElements.push(el);
      addedIds[id] = true;
      continue;
    }

    // Add all the member els from the group as targets
    const parentW = widgets[parentId] as GroupWidgetData;
    for (let j = 0; j < parentW.memberWidgetIds.length; j++) {
      const memberId = parentW.memberWidgetIds[j];
      if (!addedIds[memberId]) {
        const el = getElementForWidgetId(memberId);
        if (!el) continue;

        targetElements.push(el);
        addedIds[memberId] = true;
      }
    }
  }

  return targetElements;
};
